import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Checkbox } from "@/components/ui/checkbox";
import { Plus, Trash } from "@phosphor-icons/react";
import TaskBeforeAfter from "@/components/TaskBeforeAfter";

export default function ChecklistSection({ tasks, doneTasks, totalTasks, newTask, setNewTask, addTask, toggleTask, deleteTask, onTaskUpdate }) {
  return (
    <div className="rounded-2xl bg-white/[0.03] border border-white/10 p-4">
      <div className="flex items-center justify-between mb-3">
        <div className="text-[11px] uppercase tracking-widest text-white/50">Checklist ({doneTasks}/{totalTasks})</div>
      </div>
      <div className="space-y-2">
        {tasks.map((t) => (
          <div key={t.id} className="py-1.5 group border-b border-white/5 last:border-0 pb-2">
            <div className="flex items-center gap-3">
              <Checkbox checked={t.done} onCheckedChange={() => toggleTask(t)} className="border-white/30 data-[state=checked]:bg-[#005CFF] data-[state=checked]:border-[#005CFF]" data-testid={`task-${t.id}`} />
              <div className={`flex-1 text-sm ${t.done ? "line-through text-white/40" : ""}`}>{t.label}</div>
              <button onClick={() => deleteTask(t)} className="opacity-0 group-hover:opacity-100 text-white/40 hover:text-red-400"><Trash size={14} /></button>
            </div>
            <TaskBeforeAfter task={t} onUpdate={onTaskUpdate} />
          </div>
        ))}
        <div className="flex gap-2 mt-2">
          <Input value={newTask} onChange={(e) => setNewTask(e.target.value)} onKeyDown={(e) => e.key === "Enter" && addTask()} placeholder="Nouvelle tâche…" className="bg-white/5 border-white/10 text-sm h-10" data-testid="task-input" />
          <Button onClick={addTask} className="h-10 bg-[#005CFF] hover:bg-[#0047CC]" data-testid="task-add"><Plus size={16} weight="bold" /></Button>
        </div>
      </div>
    </div>
  );
}
